const ShimmerCart = () => {
  return (
    <div className="space-y-3">
      {[...Array(4)].map((_, i) => (
        <div
          key={i}
          className="animate-pulse rounded-xl border border-slate-100 bg-white p-4 shadow-sm"
        >
          <div className="flex gap-4">
            {/* Image */}
            <div className="h-24 w-24 rounded-lg bg-slate-200"></div>

            {/* Content */}
            <div className="flex-1 space-y-3">
              <div className="h-4 w-3/4 rounded bg-slate-200"></div>
              <div className="h-3 w-1/2 rounded bg-slate-200"></div>

              <div className="flex gap-3 mt-3">
                <div className="h-6 w-16 rounded bg-slate-200"></div>
                <div className="h-6 w-16 rounded bg-slate-200"></div>
              </div>

              <div className="mt-4 flex justify-between">
                <div className="h-8 w-24 rounded bg-slate-200"></div>
                <div className="h-8 w-20 rounded bg-slate-200"></div>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ShimmerCart;